import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  sendAutoGlassForm,
  setPolicyNumber,
} from "../../store/actions/anonymousForms";
import Styles from "./styles/WCAndGlass.module.css";
import PageWrapper from "../shared/wizard/PageWrapper";

function AnonAutoGlassForm() {
  const dispatch = useDispatch();
  const policy = useSelector((state) => state.anonymousForms.policyNumber);
  const [showWarning, setShowWarning] = useState(false);
  const buttonMessage = "File A Claim";

  const handleSubmit = (e) => {
    if (policy.length <= 7) {
      dispatch(sendAutoGlassForm(policy));
    } else {
      setShowWarning(true);
    }
  };

  const handleChange = (e) => {
    if (e.target.value.length <= 7) {
      dispatch(setPolicyNumber(e.target.value));
      setShowWarning(false);
    } else {
      dispatch(setPolicyNumber(e.target.value.substring(0, 7)));
      setShowWarning(true);
    }
  };

  return (
    <PageWrapper legendInfo="Auto Glass Claim">
      <div className={Styles.glassWCContainer}>
        <div className={Styles.row}>
          <label htmlFor="policy" className={Styles.policy}>
            Policy Number:
          </label>
          <input
            id="policy"
            value={policy}
            className={Styles.input}
            onChange={(e) => handleChange(e)}
          />
          <button className={Styles.button} onClick={(e) => handleSubmit(e)}>
            {buttonMessage}
          </button>
        </div>
        <div className={Styles.row}>
          {showWarning && (
            <p className={Styles.policyLengthWarning}>
              * Policy numbers have a maximum of 7 characters.
            </p>
          )}
        </div>
      </div>
    </PageWrapper>
  );
}

export default AnonAutoGlassForm;
